export enum Package {
  ToBeRemovedSoon = 'toBeRemovedSoon',
  DoNotEnable = 'doNotEnable',
  SpareAiPlatform = 'spareAiPlatform',
  SpareEligibilityPlatform = 'spareEligibilityPlatform',
  SpareResolvePlatform = 'spareResolvePlatform',
  SpareEnterprise = 'spareEnterprise',
  SpareOne = 'spareOne',
  SpareOpenFleets = 'spareOpenFleets',
  SpareIvr = 'spareIvr',
  SpareStandardAdminsServicePlanners = 'spareStandardAdminsServicePlanners',
  SpareStandardDispatchBookingAgents = 'spareStandardDispatchBookingAgents',
  SpareStandardDriverExperience = 'spareStandardDriverExperience',
  SpareStandardRiderExperience = 'spareStandardRiderExperience',
}
